import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from '~/contexts';
import { isRouteChunkReady, preloadRouteChunk } from '~/utils/routeConfigs';
const ROUTE_PRELOAD_LOADER = 'route-preload';
export function usePreloadNavigate() {
    const navigate = useNavigate();
    const { startLoader, stopLoader } = useOverlayContext();
    return useCallback((path)=>{
        if (isRouteChunkReady(path)) {
            navigate(path);
            return;
        }
        startLoader(ROUTE_PRELOAD_LOADER);
        void preloadRouteChunk(path).finally(()=>{
            stopLoader(ROUTE_PRELOAD_LOADER);
            navigate(path);
        });
    }, []);
}
